import React from "react";

interface TimeRangeSelectorProps {
  value: "WTD" | "MTD" | "YTD";
  onChange: (v: "WTD" | "MTD" | "YTD") => void;
  className?: string;
}
// ... inside where the options/labels are set for the buttons ...
const OPTIONS = [
  { key: "YTD", label: "YTD" },
  { key: "MTD", label: "MTD" },
  { key: "WTD", label: "WTD" },
];
export default function TimeRangeSelector({ value, onChange, className = "" }: TimeRangeSelectorProps) {
  return (
    <div className={"inline-flex rounded-lg border border-muted-foreground/10 shadow-sm bg-muted " + className}>
      {OPTIONS.map(({ key, label }) => (
        <button
          key={key}
          onClick={() => onChange(key)}
          className={
            "px-3 py-1 text-xs font-semibold rounded-lg transition focus-visible:outline-none focus-visible:ring ring-primary/40 " +
            (value === key
              ? "bg-primary/90 text-white shadow font-bold"
              : "text-muted-foreground hover:bg-primary/10")
          }
          aria-pressed={value === key}
          type="button"
        >
          {label}
        </button>
      ))}
    </div>
  );
}